import { useContext } from 'react';

import { NotificationContent } from '../components/ui/NotificationList/types';
import { NOTIFICATION_LIFETIME } from '../constants';
import { SettingsContext } from '../contexts/settings';
import { getRandomString } from '../utils';
import { UseNotifications } from './types';

type ShowNotifyProps = {
  content?: NotificationContent;
  isError: boolean;
};

export const useNotifications = (): UseNotifications => {
  const { setNotifyState } = useContext(SettingsContext);

  const clearNotify = () => {
    setTimeout(() => {
      setNotifyState((prev) => prev.slice(1));
    }, NOTIFICATION_LIFETIME);
  };

  const showNotify = ({ content, isError }: ShowNotifyProps) => {
    const id = getRandomString();

    setNotifyState((prev) => {
      if (prev.length === 3) {
        return [
          ...prev.slice(1),
          {
            content,
            id,
            isError
          }
        ];
      }

      return [
        ...prev,
        {
          content,
          id,
          isError
        }
      ];
    });
    clearNotify();
  };

  const showErrorNotify = (content?: NotificationContent) => {
    showNotify({ content, isError: true });
  };

  const showSuccessNotify = (content?: NotificationContent) => {
    showNotify({ content, isError: false });
  };

  return {
    showErrorNotify,
    showSuccessNotify
  };
};
